/* KAGAKI — "Draw Your Intention" popup behavior
   Spec: docs/brand/popups/INTENTION_CARD_POPUP_BRIEF_2026-05-09.md
   Revision v4 (2026-05-09 late):
     - Trigger timing: desktop 3.8s OR 15% scroll, mobile 4.5s OR 18% scroll
     - Intention name carries into success state (data-kg-success-intention)
     - Same frequency cap, suppress conditions, focus-trap, copy-to-clipboard
*/
(function () {
  'use strict';

  var root = document.getElementById('kg-popup');
  if (!root) return;

  // Suppress conditions
  var path = window.location.pathname;
  if (/^\/(checkout|account|cart)/.test(path)) return;
  if (path === '/cart') return;
  if (path === '/pages/find-your-intention') return;
  if (window.location.search.indexOf('nocache=') !== -1) return;
  if (/(googlebot|bingbot|crawler|spider)/i.test(navigator.userAgent || '')) return;

  // Frequency cap
  try {
    if (localStorage.getItem('kg_popup_subscribed_at')) return;
    var dismissedAt = parseInt(localStorage.getItem('kg_popup_dismissed_at') || '0', 10);
    if (dismissedAt && (Date.now() - dismissedAt) < 14 * 24 * 60 * 60 * 1000) return;
  } catch (e) {}

  var INTENTIONS = [
    { name: 'Calm',          line: 'A softer rhythm begins here.' },
    { name: 'Protection',    line: 'Let your peace stay gently guarded.' },
    { name: 'New Beginning', line: 'Something small can mark a new season.' },
    { name: 'Quiet Luck',    line: 'May quiet fortune find its way to you.' },
    { name: 'Softness',      line: 'There is strength in staying tender.' },
    { name: 'Inner Focus',   line: 'Return to the center, quietly.' }
  ];

  var shown = false;
  var currentIntention = null;
  var lastFocus = null;

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }

  function show() {
    if (shown) return;
    shown = true;
    lastFocus = document.activeElement;
    root.classList.add('kg-popup--open');
    root.setAttribute('aria-hidden', 'false');
    // Focus the primary action button (not the title) so a11y is right AND
    // the browser focus ring never renders around the headline (which read as
    // a "rectangular frame" in earlier QA).
    var primary = $('[data-kg-draw]');
    if (primary && typeof primary.focus === 'function') {
      try { primary.focus({ preventScroll: true }); } catch (_) { primary.focus(); }
    }
  }

  function dismiss(reason) {
    if (!root.classList.contains('kg-popup--open')) return;
    root.classList.remove('kg-popup--open');
    root.setAttribute('aria-hidden', 'true');
    if (reason !== 'subscribed') {
      try { localStorage.setItem('kg_popup_dismissed_at', String(Date.now())); } catch (_) {}
    }
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus(); } catch (_) {}
    }
  }

  function showStep(name) {
    var steps = root.querySelectorAll('[data-kg-step]');
    for (var i = 0; i < steps.length; i++) {
      var s = steps[i];
      if (s.getAttribute('data-kg-step') === name) {
        s.removeAttribute('hidden');
      } else {
        s.setAttribute('hidden', '');
      }
    }
  }

  function pickIntention() {
    return INTENTIONS[Math.floor(Math.random() * INTENTIONS.length)];
  }

  function onDraw() {
    currentIntention = pickIntention();
    var nameEl = $('[data-kg-intention-name]');
    var lineEl = $('[data-kg-intention-line]');
    var noteEl = $('[data-kg-note]');
    if (nameEl) nameEl.textContent = currentIntention.name;
    if (lineEl) lineEl.textContent = currentIntention.line;
    if (noteEl) noteEl.value = 'Drew intention: ' + currentIntention.name;
    showStep('card');
    var input = $('#kg-popup-email');
    if (input) {
      setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (_) {} }, 100);
    }
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function onSubmit(e) {
    e.preventDefault();
    var form = e.target;
    var emailInput = form.querySelector('#kg-popup-email');
    var email = (emailInput && emailInput.value || '').trim();
    if (!isValidEmail(email)) {
      emailInput && emailInput.focus();
      return;
    }
    var btn = form.querySelector('button[type="submit"]');
    var btnLabel = btn ? btn.querySelector('.kg-popup__button-label') : null;
    if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = 'Sending…'; }

    // KG_ATTRIBUTION_POPUP — populate attribution hidden fields + JSON note before submit
    try {
      if (window.kgAttribution && typeof window.kgAttribution.populateHiddenFields === 'function') {
        window.kgAttribution.populateHiddenFields(form, 'popup', (currentIntention && currentIntention.name) || '');
      }
    } catch (e) { try { console.warn('[kg-popup] attribution hook failed:', e); } catch (_) {} }

    var fd = new FormData(form);
    fetch('/contact', {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html, application/xhtml+xml, application/xml' }
    }).then(function () {
      onSuccess();
    }).catch(function (err) {
      try { console.warn('[kg-popup] submit error:', err); } catch (_) {}
      onSuccess();
    });
  }

  function onSuccess() {
    try { localStorage.setItem('kg_popup_subscribed_at', String(Date.now())); } catch (_) {}
    // Carry intention name into success state
    var successName = $('[data-kg-success-intention]');
    if (successName && currentIntention) {
      successName.textContent = currentIntention.name;
    }
    showStep('success');
  }

  function onCopyCode(e) {
    if (e.type === 'keydown' && !(e.key === 'Enter' || e.key === ' ')) return;
    e.preventDefault();
    var code = 'FOUNDYOU20';
    var toast = $('[data-kg-toast]');
    var copied = function () {
      if (!toast) return;
      toast.removeAttribute('hidden');
      setTimeout(function () { toast.setAttribute('hidden', ''); }, 1500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(copied, copied);
    } else {
      try {
        var range = document.createRange();
        range.selectNodeContents(e.currentTarget);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        document.execCommand && document.execCommand('copy');
        copied();
      } catch (_) {}
    }
  }

  function onKeyDown(e) {
    if (e.key === 'Escape') dismiss('escape');
  }

  // Wire events
  root.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-kg-close]')) {
      dismiss('user-close');
    }
  });
  document.addEventListener('keydown', onKeyDown);
  var drawBtn = $('[data-kg-draw]');
  if (drawBtn) drawBtn.addEventListener('click', onDraw);
  var form = $('[data-kg-form]');
  if (form) form.addEventListener('submit', onSubmit);
  var codeEl = $('[data-kg-copy]');
  if (codeEl) {
    codeEl.addEventListener('click', onCopyCode);
    codeEl.addEventListener('keydown', onCopyCode);
  }

  // Trigger: 1500ms grace, then mobile-or-desktop timing OR scroll threshold
  setTimeout(function () {
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 600px)').matches;
    var TIME_DELAY = isMobile ? 4500 : 3800; // ms after grace
    var SCROLL_PCT = isMobile ? 0.18 : 0.15;

    var scrollFired = false, timeFired = false;
    function tryShow() { if (scrollFired || timeFired) show(); }
    setTimeout(function () { timeFired = true; tryShow(); }, TIME_DELAY);
    function onScroll() {
      var pct = (window.scrollY + window.innerHeight) / Math.max(1, document.body.scrollHeight);
      if (pct >= SCROLL_PCT) {
        scrollFired = true;
        window.removeEventListener('scroll', onScroll);
        tryShow();
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }, 1500);
})();
